import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { IMenuItem, MenuButton, MenuItemType } from "azure-devops-ui/Menu";
import { Checkbox } from "azure-devops-ui/Checkbox";
import { Observer } from "azure-devops-ui/Observer";
import { Location } from "azure-devops-ui/Utilities/Position";

export default class CalloutWithAnchorElement extends React.Component {
    public render() {
        const fixedLayout = new ObservableValue<boolean>(false);
        const menuItems: IMenuItem[] = [
            {
                id: "menu-header-1",
                itemType: MenuItemType.Header,
                text: "Menu Header"
            },
            {
                checked: true,
                id: "menu-item-1",
                readonly: true,
                text: "Menu Item 1"
            },
            {
                id: "menu-item-2",
                text: "Menu Item 2"
            },
            {
                id: "menu-divider-1",
                itemType: MenuItemType.Divider
            },
            {
                id: "menu-item-3",
                text: "Menu Item 3"
            },
            {
                disabled: true,
                id: "menu-item-4",
                text: "Menu Item 4"
            }
        ];

        return (
            <Observer fixedLayout={fixedLayout}>
                {(layoutProps: { fixedLayout: boolean }) => (
                    <div className="flex-column flex-grow" style={{ margin: "8px" }}>
                        <div className="flex-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.start
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.end
                                    },
                                    menuProps: {
                                        id: "top-left",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.start
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.end
                                    },
                                    menuProps: {
                                        id: "top-center",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.start
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.end
                                    },
                                    menuProps: {
                                        id: "top-right",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                        </div>
                        <div className="flex-row" style={{ height: "8px" }} />
                        <div className="flex-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.end
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.end
                                    },
                                    menuProps: {
                                        id: "top-left-2",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.end
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.end
                                    },
                                    menuProps: {
                                        id: "top-right-2",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                        </div>
                        <div className="flex-row flex-grow">
                            <div
                                className="flex-row flex-grow flex-self-center"
                                style={{ justifyContent: "space-between", flexWrap: "wrap" }}
                            >
                                <MenuButton
                                    contextualMenuProps={{
                                        anchorOrigin: {
                                            horizontal: Location.start,
                                            vertical: Location.start
                                        },
                                        fixedLayout: layoutProps.fixedLayout,
                                        menuOrigin: {
                                            horizontal: Location.end,
                                            vertical: Location.start
                                        },
                                        menuProps: {
                                            id: "middle-left",
                                            items: menuItems
                                        }
                                    }}
                                    text="Menu Button"
                                />
                                <Checkbox
                                    checked={fixedLayout}
                                    label="Fix Layout"
                                    onChange={(event, value: boolean) => {
                                        fixedLayout.value = value;
                                    }}
                                />
                                <MenuButton
                                    contextualMenuProps={{
                                        anchorOrigin: {
                                            horizontal: Location.end,
                                            vertical: Location.start
                                        },
                                        fixedLayout: layoutProps.fixedLayout,
                                        menuOrigin: {
                                            horizontal: Location.start,
                                            vertical: Location.start
                                        },
                                        menuProps: {
                                            id: "middle-right",
                                            items: menuItems
                                        }
                                    }}
                                    text="Menu Button"
                                />
                            </div>
                        </div>
                        <div className="flex-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.start
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.start
                                    },
                                    menuProps: {
                                        id: "top-left-2",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.start
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.start
                                    },
                                    menuProps: {
                                        id: "top-right-2",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                        </div>
                        <div className="flex-row" style={{ height: "8px" }} />
                        <div className="flex-row" style={{ justifyContent: "space-between", flexWrap: "wrap" }}>
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.end
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.start
                                    },
                                    menuProps: {
                                        id: "bottom-left",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.end
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.start
                                    },
                                    menuProps: {
                                        id: "bottom-center",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                            <MenuButton
                                contextualMenuProps={{
                                    anchorOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.end
                                    },
                                    fixedLayout: layoutProps.fixedLayout,
                                    menuOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.start
                                    },
                                    menuProps: {
                                        id: "bottom-right",
                                        items: menuItems
                                    }
                                }}
                                text="Menu Button"
                            />
                        </div>
                    </div>
                )}
            </Observer>
        );
    }
}
